import React, { useState, useRef, useContext } from "react";
import { Button } from "@/modern/components/ui/button";
import { FlaskConical } from "lucide-react";
import TestPromptModal from "@/react/components/entityViews/settings/components/TestPromptModal";
import BryntumContext from "@/react/context/bryntumContext";
// @ts-expect-error - userPreferences is dynamically set in bryntumContext
import { userPreferences } from "@/react/context/bryntumContext.jsx";
import { PERSISTENCE_STATE_KEYS } from "@/other/constants/PersistenceStateKeys";
import { isIAmOneOfBoardOwner } from "@/other/utils/utils";

const TestPromptButton = () => {
  const { user, project, boardManager, selectedBoard } = useContext(BryntumContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const editorInstanceRef = useRef({ editorRef: { toFront: () => {} } });

  // @ts-expect-error - userPreferences is dynamically set in bryntumContext
  const hasOpenAIKey = userPreferences.getSetting(PERSISTENCE_STATE_KEYS.hasOpenAiApiKey, "false", true) === "true";

  // Permission check: board owner only, excluding demo users
  // @ts-expect-error - boardManager is dynamically set in bryntumContext
  const boardStore = boardManager?.boardNameStore?.getById(selectedBoard?.id);
  const isBoardOwner = project && boardStore ? isIAmOneOfBoardOwner(project, boardStore.owner) : false;
  const canWrite = isBoardOwner && !user?.isDemoUser;

  const isDisabled = !hasOpenAIKey || !canWrite;

  return (
    <>
      <Button
        onClick={() => setIsModalOpen(true)}
        variant="default"
        size="sm"
        className="shadow-sm !gap-0"
        disabled={isDisabled}
        title={!hasOpenAIKey ? "OpenAI API key required" : !canWrite ? "Board Owner permission required" : "Test the AI prompt with an image"}
      >
        <FlaskConical className="h-4 w-4 mr-2" />
        Test Prompt
      </Button>

      {isModalOpen && <TestPromptModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} editorInstance={editorInstanceRef.current} />}
    </>
  );
};

export default TestPromptButton;
